export default {"src":"https://static.eleduck.com/_next/static/media/arrow-right.53318ff4.svg","height":12,"width":4,"blurWidth":0,"blurHeight":0};